module.exports = __webpack_public_path__ + "static/media/clock-green.6bc3850d.svg";